import { render } from "./RecommendedPopup.vue?vue&type=template&id=442ef45c&ts=true"
import script from "./RecommendedPopup.vue?vue&type=script&lang=ts"
export * from "./RecommendedPopup.vue?vue&type=script&lang=ts"

import "./RecommendedPopup.vue?vue&type=style&index=0&id=442ef45c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__